export const TRIAL_STATUS_TYPES = {
  ACTIVE: 'ACTIVE',
  AUTOMATION_ACTION_PROMPT: 'AUTOMATION_ACTION_PROMPT',
  EXPIRED: 'EXPIRED',
  EXPIRING_SOON: 'EXPIRING_SOON'
};
export const TRIAL_STANDARD_DURATION = 14;